import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=080be2b8&scoped=true&"
import script from "./Popover.vue?vue&type=script&lang=js&"
export * from "./Popover.vue?vue&type=script&lang=js&"
import style0 from "./Popover.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Popover.vue?vue&type=style&index=1&id=080be2b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080be2b8",
  null
  
)

export default component.exports